var i = Object.defineProperty;
var u = (s, e, t) => e in s ? i(s, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : s[e] = t;
var a = (s, e, t) => u(s, typeof e != "symbol" ? e + "" : e, t);
const r = "default";
class l {
  constructor(e) {
    a(this, "instance");
    this.instance = e;
  }
  async get() {
    const e = await this.instance.client().makeRequest({
      method: "GET",
      url: `/v1/users/${this.instance.userId}`
    });
    return this.handleResponse(e);
  }
  async identify(e = {}) {
    const t = await this.instance.client().makeRequest({
      method: "PUT",
      url: `/v1/users/${this.instance.userId}`,
      params: e
    });
    return this.handleResponse(t);
  }
  async getAllPreferences() {
    const e = await this.instance.client().makeRequest({
      method: "GET",
      url: `/v1/users/${this.instance.userId}/preferences`
    });
    return this.handleResponse(e);
  }
  async getPreferences(e = {}) {
    const t = e.preferenceSet || r, n = await this.instance.client().makeRequest({
      method: "GET",
      url: `/v1/users/${this.instance.userId}/preferences/${t}`,
      params: { tenant: e.tenant }
    });
    return this.handleResponse(n);
  }
  async setPreferences(e, t = {}) {
    const n = t.preferenceSet || r, c = await this.instance.client().makeRequest({
      method: "PUT",
      url: `/v1/users/${this.instance.userId}/preferences/${n}`,
      data: e
    });
    return this.handleResponse(c);
  }
  async getChannelData(e) {
    const t = await this.instance.client().makeRequest({
      method: "GET",
      url: `/v1/users/${this.instance.userId}/channel_data/${e.channelId}`
    });
    return this.handleResponse(t);
  }
  async setChannelData({
    channelId: e,
    channelData: t
  }) {
    const n = await this.instance.client().makeRequest({
      method: "PUT",
      url: `/v1/users/${this.instance.userId}/channel_data/${e}`,
      data: { data: t }
    });
    return this.handleResponse(n);
  }
  handleResponse(e) {
    if (e.statusCode === "error")
      throw new Error(e.error || e.body);
    return e.body;
  }
}
export {
  l as default
};
//# sourceMappingURL=index.mjs.map
